import { Intent, Spinner, SpinnerSize } from "@blueprintjs/core"
import React from "react"

type SplashLoaderProps = {
  intent?: Intent
  children?: React.ReactNode
}
const SplashLoader = ({ intent, children }: SplashLoaderProps) => {
  return (
    <div className="vt-loading">
      <Spinner intent={intent} size={SpinnerSize.STANDARD} />
      <h4 className="text-center pt-5 text-muted">{children}</h4>
    </div>
  )
}
export default SplashLoader
